import React from 'react'

import BaseLink from 'shared/components/BaseLink'
import { BUILD_TIMESTAMP } from 'buildTimestamp'
import './style.scss'

const IntroductionBlock = () => (
  <div className="introduction-section">
    <div className="introduction-blocks">
      <div className="introduction-block text-light">
        <h3>ABOUT</h3>
        <p>
          The Displacement Alert Project (DAP) Portal is a dynamic and powerful data tool that helps you understand a New
          York City neighborhood’s housing landscape, where tenants and homeowners are at heightened risk of displacement,
          and what is happening in buildings where tenants or homeowners are having problems.
        </p>
        <p>DAP Portal is made up of three features:</p>
        <p>
          The <BaseLink href="/lookup">Property Lookup</BaseLink> lets you investigate displacement threats at a building
          level, view detailed records over time, find patterns and connections, and get the most recent information
          possible.
        </p>
        <p>
          The <BaseLink href="/district-dashboard">District Dashboard</BaseLink> allows you to apply displacement threat indicators
          across districts or zip codes to see a broader snapshot of threats by neighborhood, and produce maps and lists
          of buildings that might not be on your radar for outreach and organizing.
        </p>
        <p>
          The <BaseLink href="/search">Custom Search</BaseLink> allows you to customize maps and lists of buildings that
          meet your unique search criteria and answer specific research questions about the threats facing our
          neighborhoods.
        </p>
        <p className="mb-0">
          The DAP Portal is made possible by the support of the New York City Council and New York State Senate.
        </p>
      </div>

      <div className="introduction-block text-light">
        <h3>The Displacement Alert Project</h3>
        <p>
          In New York City, ending displacement is one of the most urgent issues we face.{' '}
          <BaseLink href="https://displacementalert.org">The Displacement Alert Project</BaseLink> is designed to address
          this problem by providing effective early warning information for residents facing harassment and displacement,
          for communities being destabilized, and for the community groups and policy makers trying to address the crisis.
        </p>
        <p>
          Existing data and information is fragmented and often confusing, which can make it challenging to identify which
          buildings are most vulnerable in order to intervene.
        </p>
        <p>
          We use data and information visualization tools to proactively identify buildings that are facing a rising risk
          of displacement. With this information community groups, decision makers, and local residents themselves can
          take strategic steps to push back with outreach, education, and organizing strategies.
        </p>
        <p>
          The Displacement Alert Project is operated by the{' '}
          <BaseLink href="https://anhd.org">Association for Neighborhood and Housing Development (ANHD)</BaseLink>.
        </p>
        <p className="mb-0">
          For a detailed analysis of annual data that highlights and ranks indicators of demographics and housing risk in each
          of New York City’s 59 community districts, visit{' '}
          <BaseLink target="_blank" href="https://risk.anhd.org/">ANHD&apos;s Housing Risk Map</BaseLink>.
        </p>
      </div>
    </div>

    <p className="introduction-credit text-center mb-0">
      Developed by <BaseLink href="https://blueprintinteractive.com">Blueprint Interactive</BaseLink>.
      <span style={{ visibility: 'hidden', position: 'absolute' }} aria-hidden="true">
        Frontend last updated: {BUILD_TIMESTAMP}
      </span>
    </p>
  </div>
)

export default IntroductionBlock
